export default "__VITE_ASSET__Cdo7_pPV__"